

/*function report( getReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)

                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}*/


/**
 * 装饰器-负责上报
 *
 * @reportListOrgetReportValueFn 上报参数，接受的参数格式有如下几种：
 * {
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      key: '',
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      targetSelector: '#id.class',
 *      eventName: 'click',
 *      params: function(){},
 *      action: reportFunction(e, params)
 * }
 *
 */
export function report( reportListOrgetReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                /*let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)

                return targetFunction.call(this, ...arg)*/
                if(Array.isArray(reportListOrgetReportValueFn)){
                    let reportList = reportListOrgetReportValueFn
                    reportList.forEach(report=>{
                        let args = []
                        const {key, value, targetSelector, eventName, action, params, condition } = report
                        let reportCondition = true
                        if(typeof condition === 'function'){
                            reportCondition = condition.call(this)
                        }
                        if(!!reportCondition){
                            if(key || value){
                                value && args.push('function'===typeof value ? value.call(this) : value)
                                key && args.push(key)
                                console.log('上报参数====>', args, key, value)
                                action.apply(this, args)
                            }else if(targetSelector && eventName){
                                const targetEl = document.querySelector(targetSelector)
                                console.log('上报参数-click ====>', targetEl, targetSelector, eventName)
                                targetEl && targetEl.addEventListener(eventName, (e)=> {
                                    //const target = e.target || e.srcElement || e.currentTarget
                                    console.log('do ------- 点击上报',e)
                                    //console.log('do ------- container',proxySelector,targetSelector, targetEl.classList, this)
                                    let _params = params&&params.call(this) || {}
                                    action.call(this, e, _params);

                                }, false)
                            }
                        }


                    })
                }
                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}
